/* K MANNAM v23: storefront-only shipping UX. Checkout still requires ASR.
 * Cart groups are derived from product tags in Liquid/Section Rendering, never shopper properties.
 * Customer ZIP is informational and never overwrites the checkout shipping address.
 */
(function () {
 'use strict';
 if (window.KMShippingUI) return;
 var core=window.KMShippingCore, cfgNode=document.querySelector('[data-km-shipping-config]');
 if (!core || !cfgNode) return;
 var config;
 try { config=JSON.parse(cfgNode.textContent); } catch(e) { console.error('K MANNAM shipping config:',e); return; }
 if (!config.enabled) return;
 // Data-file opt-in only: approved=false + provisional.enabled=true enables approximate postal areas. Legacy demo settings are ignored.
 config.policy=config.policy || {};
 if (config.feeInput!==undefined) config.policy.underFee=core.parseMoney(config.feeInput);
 var ko=String(config.locale).slice(0,2)==='ko', cart=null, zones=null, zip='', fresh=false, busy=0;
 var loadFailed=false;
 var renderQueued=false, refreshTimer=0, fetchId=0, revision=0, loadingData=false, syncPending=false;
 var originalFetch=window.fetch.bind(window), current=null, modal=document.querySelector('[data-km-zip-modal]');
 var input=modal && modal.querySelector('[data-km-zip-input]'), error=modal && modal.querySelector('[data-km-zip-error]');
 var previousFocus=null, inerted=[], savedBodyOverflow='', saveTimer=0;
 var KEY='kmannam_shipping_zip';
 function tr(k,e) { return ko?k:e; }
 function money(n) { return new Intl.NumberFormat(ko?'ko-KR':'en-US',{style:'currency',currency:'USD',currencyDisplay:'narrowSymbol',minimumFractionDigits:2,maximumFractionDigits:2}).format(n/100); }
 function readPayload(scope) {
   var nodes=scope.querySelectorAll('[data-km-cart-payload]');
   if (!nodes.length) return null;
   try { var c=JSON.parse(nodes[nodes.length-1].textContent); return Array.isArray(c.items) ? c : null; } catch(e) { return null; }
 }
 try { zip=core.normalizeZip(localStorage.getItem(KEY)); } catch(e) { /* Private/storage-disabled browsing remains usable. */ }
 cart=readPayload(document); fresh=!!cart;
 if (!zip && cart) zip=core.normalizeZip(cart.savedZip);
  if (zip && cart && core.normalizeZip(cart.savedZip)!==zip) persistZip(zip);
 function put(el,value) { if (el && el.textContent!==value) el.textContent=value; }
 function all(selector,fn) { document.querySelectorAll(selector).forEach(fn); }
 function statusText(r) {
   if (!fresh && loadFailed && !busy) return tr('배송정보를 불러오지 못했습니다. 페이지를 새로고침하거나 다시 시도해 주세요.','Shipping information could not be loaded. Refresh or retry.');
   if (busy || !fresh) return tr('장바구니 배송정보를 다시 확인하고 있습니다.','Refreshing cart shipping details.');
   switch(r.status) {
    case 'zip_required':return tr('ZIP Code를 입력해 배송 기준을 확인해 주세요.','Enter your ZIP code to check shipping.');
    case 'zones_pending':return tr('배송 가능 ZIP 목록을 확인 중입니다. 고객센터로 문의해 주세요.','Shipping policy for this ZIP needs confirmation. Check final rates at checkout.');
    case 'zones_error':case 'policy_error':return tr('배송 설정 확인이 필요합니다. 고객센터로 문의해 주세요.','Shipping settings need review. Please contact support.');
    case 'zip_unconfirmed':return tr('입력한 ZIP의 배송 가능 여부를 확인해 주세요. 고객센터로 문의해 주세요.','Delivery to this ZIP is not confirmed. Please contact support.');
    case 'restricted':return tr('입력하신 주소는 현재 배송이 제한된 지역입니다. 자세한 내용은 고객센터로 문의해 주세요.','Delivery is restricted for this ZIP. Please contact support.');
    case 'classification':return tr('일부 상품의 배송유형 확인이 필요합니다. 고객센터로 문의해 주세요.','Some items have missing or conflicting shipping tags. Please contact support.');
    case 'inventory':return tr('품절 또는 재고 부족 상품이 있습니다. 수량을 조정하거나 삭제해 주세요.','Some items are unavailable or exceed stock. Adjust quantities or remove them.');
    case 'tax_mode':return tr('세금 포함 가격의 배송 기준은 별도 확인이 필요합니다. 결제 단계에서 확인해 주세요.','Tax-inclusive pricing requires separate shipping review. Please confirm at checkout.');
    case 'country':return tr('미국 스토어로 전환한 뒤 배송 기준을 확인해 주세요.','Switch to the United States storefront to check shipping.');
    case 'currency':return tr('배송 기준은 USD입니다. USD 스토어에서 다시 확인해 주세요.','Shipping thresholds are in USD. Please use the USD storefront.');
    case 'cart_error':return tr('배송정보를 불러오지 못했습니다. 다시 시도해 주세요.','Shipping information could not be loaded. Please retry.');
    case 'empty':return r.zone ? tr('Zone '+r.zone+' · 실온 '+money(r.roomThreshold)+' / 냉장·냉동 '+money(r.coldThreshold)+' 이상 무료배송','Zone '+r.zone+' · Ambient '+money(r.roomThreshold)+' / Cold '+money(r.coldThreshold)+' for free shipping') : tr('일반상품을 담으면 무료배송까지 남은 금액을 안내합니다.','Add regular items to see your free shipping progress.');
    case 'digital':return tr('배송이 필요 없는 상품입니다.','These items do not require shipping.');
    case 'standalone':return tr('단독·벌크 무료배송 상품만 담겨 있습니다. 배송비 $0 · 최소 주문금액 없음.','Only standalone free-shipping items: $0 shipping, no minimum.');
    case 'minimum':return tr(money(r.minimumRemaining)+' 더 담아 주세요.','Regular merchandise minimum: '+money(r.minimum)+'. Add '+money(r.minimumRemaining)+' to proceed.');
    case 'free':return tr('일반상품 무료배송 기준을 충족했습니다.','Regular merchandise qualifies for free shipping.');
    default:return tr('무료배송까지 '+money(r.remaining)+' 남았습니다.','Add '+money(r.remaining)+' for free shipping.');
   }
 }
 function fact(dl,label,value,kind) {
   var div=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');
   if(kind)div.dataset.kmFact=kind;dt.textContent=label;dd.textContent=value;div.append(dt,dd);dl.appendChild(div);
 }
 // v27 / request 10: full-cart presentation only. The policy engine is unchanged.
 function isMainCart(el) { return !!el.closest('[data-km-cart-v27]'); }
 function holdCartNode(el,ready) {
   if(!isMainCart(el)) return false;
   if(ready) { el.dataset.kmCartRendered='true'; return false; }
   return !loadFailed && el.dataset.kmCartRendered==='true';
 }
 function cartMethods(r) {
   var names=[];
   if(r.hasRegular) names.push(tr('바로배송','Regular delivery'));
   if(r.hasFree) names.push(tr('무료 단독 배송','Standalone free shipping'));
   return names.join(' / ');
 }
 function renderCartTotals(r,ready) {
   all('[data-km-cart-v27]',function(page){
     var totals=page.querySelector('[data-km-cart-totals]');
     if(!totals)return;
     var currency=totals.dataset.kmCartCurrency, total=Number(totals.dataset.kmMerchandiseTotal);
     // Never attach a new rate to old merchandise DOM during a quantity request.
     var valid=ready && cart && currency==='USD' && cart.currency==='USD' &&
       Number.isSafeInteger(total) && total>=0 && total===cart.total &&
       ['paid','free','standalone','digital'].indexOf(r.status)!==-1 &&
       Number.isSafeInteger(r.fee) && r.fee>=0;
     totals.setAttribute('aria-busy',(!ready).toString());
     page.querySelectorAll('[data-km-cart-shipping-price]').forEach(function(el){put(el,valid?money(r.fee):'—');});
     page.querySelectorAll('[data-km-cart-inclusive-price]').forEach(function(el){put(el,valid?money(total+r.fee):'—');});
   });
 }
 function render() {
   renderQueued=false;
   var r=core.calculate(cart,zip,zones,config.policy); current=r;
   var status=statusText(r), ready=fresh && !busy;
   all('[data-km-zip]',function(el){put(el,zip||'ZIP');});

   var headerReady=ready && r.zone && r.roomThreshold!==null && r.coldThreshold!==null;
   var maxThreshold=headerReady?Math.max(r.roomThreshold,r.coldThreshold):0;
   // Keep the two free-shipping milestones visually separated like the reference site.
   // The first threshold always sits at the midpoint and the second at the end;
   // cart progress is mapped piecewise so each real threshold still lands on its marker.
   var roomPosition=50;
   var coldPosition=100;
   var headerPercent=0;
   var minimumAnchor=Number(config.policy.minimum);
   if(!Number.isFinite(minimumAnchor) || minimumAnchor<0) minimumAnchor=3000;
   if(headerReady && maxThreshold>0){
     if(r.coldThreshold>r.roomThreshold && r.roomThreshold>minimumAnchor){
       if(r.regular<=r.roomThreshold){
         headerPercent=Math.min(50,Math.max(0,(r.regular-minimumAnchor)/(r.roomThreshold-minimumAnchor)*50));
       }else if(r.regular<r.coldThreshold){
         headerPercent=50+((r.regular-r.roomThreshold)/(r.coldThreshold-r.roomThreshold)*50);
       }else{
         headerPercent=100;
       }
     }else if(maxThreshold>minimumAnchor){
       headerPercent=Math.min(100,Math.max(0,(r.regular-minimumAnchor)/(maxThreshold-minimumAnchor)*100));
     }else{
       headerPercent=r.regular>=maxThreshold?100:0;
     }
   }
   all('[data-km-min-amount]',function(el){put(el,money(minimumAnchor));});
   all('[data-km-room-amount]',function(el){put(el,headerReady?money(r.roomThreshold):'--');});
   all('[data-km-cold-amount]',function(el){put(el,headerReady?money(r.coldThreshold):'--');});
   all('[data-km-room-marker]',function(el){el.style.left=roomPosition+'%';});
   all('[data-km-room-label]',function(el){el.style.left=roomPosition+'%';});
   all('[data-km-cold-marker]',function(el){el.style.left=coldPosition+'%';});
   all('[data-km-header-fill]',function(el){el.style.width=headerPercent+'%';});
   all('[data-km-header-note]',function(el){
    var note=r.status==='standalone' ? tr('무료단독배송 상품','Standalone free shipping') : status;
    if(headerReady && r.status!=='standalone' && r.status!=='minimum'){
      var activeThreshold=r.cold?r.coldThreshold:r.roomThreshold;
      var left=Math.max(0,activeThreshold-r.regular);
      if(r.regular>=activeThreshold){
        note=r.cold?tr('냉장·냉동 무료배송!','Cold Free Shipping!'):tr('실온 무료배송!','Ambient Free Shipping!');
      }else{
        note=money(left)+' '+tr('더 담으면 무료배송!','more to go!');
      }
    }
    put(el,note);
   });
   all('[data-km-shipping-open]',function(el){
    if(el.classList.contains('km-shipping-widget'))el.title=status;
   });

   all('[data-km-group-estimate]',function(el){
    if(holdCartNode(el,ready))return;
    var group=el.getAttribute('data-km-group-estimate'), message='';
    if(ready && r.zone && r.roomThreshold!==null && r.coldThreshold!==null){
      if(group==='NORMAL_COLD' && r.counts.NORMAL_COLD>0){
        message='Zone '+r.zone+' · '+r.service+' · '+tr('일반상품 합계 ','Regular subtotal ')+money(r.regular)+' · '+tr('무료배송 ','Free over ')+money(r.coldThreshold);
        if(r.fee!==null)message+=' · '+(r.fee===0?tr('무료배송','Free Shipping'):tr('배송비 ','Shipping ')+money(r.fee));
      } else if(group==='NORMAL_ROOM' && r.counts.NORMAL_ROOM>0){
        if(r.cold){
          message=tr('냉장·냉동 포함 주문 기준 적용 · ','Cold-item threshold applies · ')+'Zone '+r.zone+' · '+r.service+' · '+tr('일반상품 합계 ','Regular subtotal ')+money(r.regular)+' · '+tr('무료배송 ','Free over ')+money(r.coldThreshold);
        }else{
          message='Zone '+r.zone+' · UPS Ground · '+tr('일반상품 합계 ','Regular subtotal ')+money(r.regular)+' · '+tr('무료배송 ','Free over ')+money(r.roomThreshold);
        }
        if(r.fee!==null)message+=' · '+(r.fee===0?tr('무료배송','Free Shipping'):tr('배송비 ','Shipping ')+money(r.fee));
      } else if(group==='FREE_COLD' && r.counts.FREE_COLD>0){
        message=tr('단독 배송 · UPS 1-Day · 무료배송 $0 · 일반배송 무료배송 기준에서 제외','Separate shipment · UPS 1-Day · Free Shipping $0 · Excluded from regular threshold');
      } else if(group==='FREE_ROOM' && r.counts.FREE_ROOM>0){
        message=tr('단독 배송 · UPS Ground · 무료배송 $0 · 일반배송 무료배송 기준에서 제외','Separate shipment · UPS Ground · Free Shipping $0 · Excluded from regular threshold');
      }
    }
    put(el,message);
   });

   // One regular charge, never duplicate cold + ambient shipping fees.
   var quoteValid=ready && ['paid','free','minimum','standalone'].indexOf(r.status)!==-1;
   all('[data-km-group-estimate="REGULAR"]',function(el){
     if(holdCartNode(el,ready))return;
     put(el,quoteValid && r.hasRegular ? 'Zone '+r.zone+' · '+(isMainCart(el)?tr('바로배송','Regular delivery'):r.service)+' · '+tr('무료배송 기준 ','Free over ')+money(r.threshold) : status);
   });
   all('[data-km-group-estimate="STANDALONE"]',function(el){
     if(holdCartNode(el,ready))return;
     put(el,quoteValid ? (isMainCart(el)?tr('무료 단독 배송','Standalone free shipping'):tr('단독무료배송 · 냉장/냉동 UPS 1-Day / 상온 UPS Ground','Standalone free · Cold UPS 1-Day / Ambient UPS Ground')) : status);
   });
   all('[data-km-bucket-progress]',function(el){if(holdCartNode(el,ready))return;el.hidden=!(quoteValid && r.hasRegular && r.threshold!==null);});
   all('[data-km-bucket-fill]',function(el){if(holdCartNode(el,ready))return;el.style.width=quoteValid?r.percent+'%':'0%';});
   all('[data-km-bucket-remaining]',function(el){if(holdCartNode(el,ready))return;put(el,quoteValid && r.hasRegular ? status : '');});
   all('[data-km-bucket-fee]',function(el){
     var group=el.dataset.kmBucketFee;
     var fee=group==='STANDALONE' && quoteValid ? 0 : (quoteValid?r.fee:null);
     put(el,fee===null ? tr('결제 단계 확인','Confirm at checkout') : money(fee));
   });
   document.dispatchEvent(new CustomEvent('km:shipping:updated',{detail:{estimate:r,fresh:ready}}));

   all('[data-km-shipping-summary]',function(box){
    var mainCart=box.hasAttribute('data-km-cart-summary');
    box.setAttribute('aria-busy',(!ready).toString());
    if(holdCartNode(box,ready))return;
    put(box.querySelector('[data-km-summary-status]'),status);
    var progress=box.querySelector('[data-km-summary-progress]');if(progress)progress.hidden=!(ready && r.threshold!==null);
    var fill=box.querySelector('[data-km-summary-fill]');if(fill)fill.style.width=(ready?r.percent:0)+'%';
    var dl=box.querySelector('[data-km-summary-facts]');
    var signature=JSON.stringify([r.zone,r.regular,r.standalone,r.excluded,r.status,r.threshold,r.fee,r.service,ready,r.groups]);
    if (dl && dl.dataset.signature!==signature) {
      dl.replaceChildren();dl.dataset.signature=signature;
      if (ready && cart && cart.currency==='USD') {
       if (r.zone) fact(dl,tr('배송 Zone','Delivery zone'),'Zone '+r.zone);
       if (r.hasRegular) {
        fact(dl,tr('일반배송 기준 상품금액','Regular shipping subtotal'),money(r.regular),'regular');
        fact(dl,tr('냉장·냉동 / 실온','Cold / Ambient'),money(r.groups.NORMAL_COLD)+' / '+money(r.groups.NORMAL_ROOM));
       }
       if (r.hasFree) fact(dl,tr('단독 무료배송 상품','Standalone free-shipping items'),money(r.standalone),'standalone');
       if (r.excluded) fact(dl,tr('기타 제외 금액','Other excluded amount'),money(r.excluded));
       if (r.status==='empty') { fact(dl,tr('실온 무료배송 기준','Ambient free shipping'),money(r.roomThreshold)); fact(dl,tr('냉장·냉동 무료배송 기준','Cold free shipping'),money(r.coldThreshold)); }
       if (r.hasRegular && r.threshold!==null) fact(dl,tr('적용 무료배송 기준','Applied free-shipping threshold'),money(r.threshold));
       if (!mainCart && quoteValid && r.counts.FREE_COLD) fact(dl,tr('단독무료 냉장·냉동','Standalone free · Cold'),'UPS 1-Day · $0');
       if (!mainCart && quoteValid && r.counts.FREE_ROOM) fact(dl,tr('단독무료 실온','Standalone free · Ambient'),'UPS Ground · $0');
       if(mainCart){
        var methods=cartMethods(r);
        if(methods)fact(dl,tr('배송방법','Shipping method'),methods,'methods');
       }else{
        if (r.service) fact(dl,tr('일반배송 방법','Regular delivery service'),r.service);
        if (r.transit) fact(dl,tr('출고 후 예상 기간','Transit after dispatch'),r.transit+tr('영업일',' business days'));
       }
       if (r.fee!==null) fact(dl,tr('예상 배송비','Estimated shipping'),money(r.fee),'fee');
      }
    }
    var dispatch='';
    if (quoteValid && (r.hasRegular || r.hasFree)) {
     var anyCold=r.counts.NORMAL_COLD+r.counts.FREE_COLD>0;
     dispatch=anyCold ? tr('냉장·냉동: 월–목 출고, 오후 3시 Pacific 마감. 목요일 마감 이후는 다음 월요일 또는 다음 영업일.','Cold items: Mon–Thu dispatch, 3 PM Pacific cutoff. After Thursday cutoff: next Monday or next business day.') : tr('실온: 월–금 출고, 오후 3시 Pacific 마감. 금요일 마감 이후는 다음 월요일 또는 다음 영업일.','Ambient items: Mon–Fri dispatch, 3 PM Pacific cutoff. After Friday cutoff: next Monday or next business day.');
     dispatch+=' '+tr('재고 준비 시 · 주말/공휴일 출고 없음.','Subject to stock readiness. No weekend or holiday dispatch.');
    }
    put(box.querySelector('[data-km-summary-dispatch]'),dispatch);
    put(box.querySelector('[data-km-summary-fine]'),tr('무료배송 기준은 일반배송 상품의 쿠폰·적립금 적용 전 상품금액을 기준으로 하며, 단독·벌크 무료배송 상품은 별도 배송됩니다. 표시 배송비는 예상 금액이며 최종 배송비·배송 가능 여부는 결제 단계의 실제 배송주소 기준으로 확인해 주세요.','Free-shipping thresholds use regular merchandise totals before coupons or rewards. Standalone free-shipping items ship separately. Rates shown are estimates; confirm final rates and delivery availability at checkout using the actual shipping address.'));
    var warn=box.querySelector('[data-km-summary-warning]');
    if(warn){
      warn.hidden=!(ready && r.hasFree && r.hasRegular);
      put(warn,tr('단독 무료배송 상품은 일반배송 상품과 별도로 출고되며, 해당 금액은 일반배송 무료배송 기준에 포함되지 않습니다.','Standalone free-shipping items ship separately and do not count toward the regular free-shipping threshold.'));
    }
   });
   renderCartTotals(r,ready);
   all('[data-km-checkout]',function(button){
    var block=config.guard && !config.editor && (!ready || !r.allow);
    button.setAttribute('aria-disabled',block?'true':'false');button.classList.toggle('km-checkout-guarded',block);
   });
   all('[data-km-shipping-editor-note]',function(el){el.remove();});
 }
 function scheduleRender(){if(!renderQueued){renderQueued=true;requestAnimationFrame(render);}}
 function refreshSoon(delay){clearTimeout(refreshTimer);refreshTimer=setTimeout(refresh,delay===undefined?200:delay);}
 async function refresh() {
   if(busy){refreshSoon(200);return;}
   if(loadingData){syncPending=true;return;}
   loadingData=true;loadFailed=false;var id=++fetchId, rev=revision;
   var url=new URL(config.cartUrl,document.baseURI);url.searchParams.set('section_id','km-shipping-data');url.searchParams.set('_km',String(Date.now()));
   var controller=new AbortController(), timeout=setTimeout(function(){controller.abort();},10000);
   try {
    var response=await originalFetch(url.href,{credentials:'same-origin',cache:'no-store',signal:controller.signal});
    if(!response.ok)throw new Error('HTTP '+response.status);
    var doc=new DOMParser().parseFromString(await response.text(),'text/html'), data=readPayload(doc);
    if(!data)throw new Error('Shipping cart JSON is missing');
    if(id===fetchId && rev===revision && !busy){cart=data;fresh=true;if(zip && core.normalizeZip(data.savedZip)!==zip)persistZip(zip);}
    else syncPending=true;
   } catch(e) { if(id===fetchId){fresh=false;loadFailed=true;console.warn('K MANNAM shipping refresh:',e);} }
   finally {clearTimeout(timeout);loadingData=false;scheduleRender();if(syncPending){syncPending=false;refreshSoon(180);}}
 }
 async function loadZones(){
   try {
    var data=config.editorZones;
    if(config.zipSource!=='editor'){
     var ctrl=new AbortController(),timeout=setTimeout(function(){ctrl.abort();},10000);
     try {var response=await originalFetch(config.zonesUrl,{credentials:'omit',signal:ctrl.signal});if(!response.ok)throw new Error('ZIP file unavailable');data=await response.json();}finally{clearTimeout(timeout);}
    }
    zones=core.compileZones(data);if(zones.errors.length)console.warn('K MANNAM ZIP config:',zones.errors);
   }catch(e){zones=core.compileZones({approved:false});console.warn('K MANNAM ZIP config unavailable:',e);}
   scheduleRender();
 }
 // Monitor only same-origin cart mutations; leave theme fetch responses untouched.
 window.fetch=function(resource,options){
   var url,method,mutation=false;
   try{
    url=new URL(typeof resource==='string'?resource:resource.url,location.origin);
    method=String((options && options.method) || (resource && resource.method) || 'GET').toUpperCase();
    mutation=url.origin===location.origin && method!=='GET' && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
   }catch(e){}
   if(!mutation)return originalFetch(resource,options);
   busy++;revision++;fresh=false;scheduleRender();
   return originalFetch(resource,options).finally(function(){busy=Math.max(0,busy-1);refreshSoon(180);});
 };
 function acceptMainCartPayload() {
   var page=document.querySelector('[data-km-cart-v27]');
   if(!page || busy)return false;
   var data=readPayload(page);if(!data)return false;
   revision++;cart=data;fresh=true;loadFailed=false;clearTimeout(refreshTimer);
   render();return true;
 }
 function markCartChanged(event){
   if(event && event.type==='cart:rerendered' && acceptMainCartPayload())return;
   fresh=false;scheduleRender();refreshSoon(180);
 }
 ['cart:rerendered','cart:updated','cart:refresh','cart:change'].forEach(function(name){document.addEventListener(name,markCartChanged,true);});
 window.addEventListener('pageshow',function(e){if(e.persisted)markCartChanged();});
 // Capture rerendered DOM from legacy cart, sections, and third-party drawers.
 new MutationObserver(function(records){
   var ui=false,payload=false;
   records.forEach(function(r){r.addedNodes.forEach(function(n){
    if(n.nodeType!==1)return;
    if(n.matches('[data-km-cart-payload]') || n.querySelector('[data-km-cart-payload]'))payload=true;
    if(n.matches('[data-km-shipping-summary],[data-km-shipping-open],[data-km-checkout]') || n.querySelector('[data-km-shipping-summary],[data-km-shipping-open],[data-km-checkout]'))ui=true;
   });});
   if(payload && !acceptMainCartPayload())refreshSoon(200);
   if(ui)scheduleRender();
 }).observe(document.body,{childList:true,subtree:true});
 function openModal(){
   if(!modal || !modal.hidden)return;
   previousFocus=document.activeElement;input.value=zip;put(error,'');input.removeAttribute('aria-invalid');
   if(modal.parentElement!==document.body)document.body.appendChild(modal);
   modal.hidden=false;savedBodyOverflow=document.body.style.overflow;document.body.style.overflow='hidden';document.body.classList.add('km-modal-open');
   inerted=[];Array.from(document.body.children).forEach(function(el){
    if(el!==modal && el.tagName!=='SCRIPT' && el.tagName!=='STYLE' && !el.inert){el.inert=true;inerted.push(el);}
   });
   input.focus();input.select();
 }
 function closeAfterApply(){
   modal.hidden=true;inerted.forEach(function(el){el.inert=false;});inerted=[];
   document.body.style.overflow=savedBodyOverflow;document.body.classList.remove('km-modal-open');
   if(previousFocus && previousFocus.isConnected && previousFocus!==document.body)previousFocus.focus();
 }
 function persistZip(value){
   // Attributes are advisory only, never trusted for checkout eligibility/discounts.
   clearTimeout(saveTimer);
   saveTimer=setTimeout(function(){
    if(busy || loadingData){persistZip(value);return;}
    var saveUrl=new URL(config.cartUrl+'/update.js',document.baseURI);
    originalFetch(saveUrl.href,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{km_shipping_zip:value}})})
      .catch(function(e){console.warn('K MANNAM ZIP attribute could not be saved:',e);});
   },300);
 }
 document.addEventListener('click',function(e){
   var opener=e.target.closest('[data-km-shipping-open]');
   if(opener){e.preventDefault();openModal();return;}
   var checkout=e.target.closest('[data-km-checkout],a[href="/checkout"],a[href^="/checkout?"]');
   if(checkout && config.guard && !config.editor && (!fresh || busy || !current || !current.allow)){
     e.preventDefault();e.stopImmediatePropagation();showCheckoutMessage();
   }
 },true);
 function showCheckoutMessage(){
   var msg=current?statusText(current):tr('배송정보 확인 후 다시 시도해 주세요.','Please wait for shipping details and retry.');
   all('[data-km-checkout-message]',function(el){el.hidden=false;put(el,msg);});
   var box=document.querySelector('[data-km-shipping-summary]');if(box)box.scrollIntoView({behavior:'smooth',block:'center'});
   if(!zip)openModal();else refreshSoon(0);
 }
 document.addEventListener('submit',function(e){
   var form=e.target;
   if(form.matches('[data-km-zip-form]')){
    e.preventDefault();var next=core.normalizeZip(input.value);
    if(!next || next==='00000' || next==='99999'){put(error,tr('유효한 5자리 ZIP Code를 입력해 주세요.','Please enter a valid 5-digit ZIP code.'));input.setAttribute('aria-invalid','true');input.focus();return;}
    zip=next;try{localStorage.setItem(KEY,zip);}catch(err){}
    closeAfterApply();persistZip(zip);scheduleRender();
    document.dispatchEvent(new CustomEvent('km:zip:changed',{detail:{zip:zip}}));
   }else if(config.guard && !config.editor && form.matches('form.cart-recap,form.mini-cart') && (!fresh || busy || !current || !current.allow)){
    e.preventDefault();e.stopImmediatePropagation();showCheckoutMessage();
   }
 },true);
 document.addEventListener('keydown',function(e){
   if(!modal || modal.hidden)return;
   if(e.key==='Escape'){e.preventDefault();e.stopImmediatePropagation();return;}
   if(e.key==='Tab'){
    var focusables=modal.querySelectorAll('input,button,[tabindex="0"]'), first=focusables[0],last=focusables[focusables.length-1];
    if(e.shiftKey && (document.activeElement===first || !modal.contains(document.activeElement))){e.preventDefault();last.focus();}
    else if(!e.shiftKey && (document.activeElement===last || !modal.contains(document.activeElement))){e.preventDefault();first.focus();}
   }
 },true);
 document.addEventListener('focusin',function(e){if(modal && !modal.hidden && !modal.contains(e.target))input.focus();});
 window.addEventListener('storage',function(e){if(e.key===KEY){zip=core.normalizeZip(e.newValue);scheduleRender();if(!zip)openModal();}});
 document.addEventListener('shopify:section:load',function(){scheduleRender();refreshSoon(0);});
 document.addEventListener('visibilitychange',function(){if(!document.hidden)refreshSoon(0);});
 window.KMShippingUI={refresh:markCartChanged,openZip:openModal,getEstimate:function(){return current;}};
 scheduleRender();loadZones();if(!fresh)refreshSoon(0);
 if(!zip && !config.editor)openModal();
})();
